import clientInformation, { getClientItem } from '../login/ClientInfo';
import { RequestACHPayout } from "../../services/PayoutService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken, GetCustomerInfo, GetCountries, GetStatesbyCountry } from "../../services/AuthenticationService";
import BeatLoader from "react-spinners/BeatLoader";
import { onlyNumbers, BonusString } from '../helpers/common';
import { isMobile } from 'react-device-detect';
import { useTranslations } from '../../context/LanguageContext';
import translations from '../../translations/PayoutACHMethods';

export const PayoutACHMethods = () => {
    const t = useTranslations(translations);
    const clientInfo = clientInformation();
    let INSTANCEID = clientInfo.InstanceID;
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isProcessing, setIsProcessing] = useState(false);
    const { id } = useParams();
    const [arrayPayouts, setPayouts] = useState(JSON.parse(getClientItem('arrayPayoutsMethods')).filter(function (element) { return element.PayoutID === id; })[0]);
    const navigate = useNavigate();
    const [arrayCustomerInfo, setArrayCustomerInfo] = useState([]);
    const [showComponent, setshowComponent] = useState(false);
    const [OriginalAmount, setOriginalAmount] = useState(0);
    const [arrayCountries, setArrayCountries] = useState([]);
    const [arrayStates, setArrayStates] = useState([]);
    const [stateCode, setStateCode] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [othForm, setOthForm] = useState({ CheckTypes: '' });
    const CheckTypes = [{ key: 1, text: t.personalChecking, value: '200510' }, { key: 2, text: t.personalSavings, value: '200520' }];
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(async function (response) {
            await GetCountries(getClientItem('Token')).then(async function (response) {
                var i = 0;
                const filtered = response.Authentication.map(item => {
                    const {
                        Code,
                        Name } = item;

                    return { Key: i++, Code, Name }
                });
                setArrayCountries(filtered);
                setCountryCode('US');
                handleStatebyCountry('US', true);
            });
        })
            .catch(function (error) {
                navigate('/expired/');
            })

        if (arrayPayouts === undefined) {
            navigate('/payouts/');
        }
        CustomerInfo();

    }, [])

    async function CustomerInfo() {
        await GetCustomerInfo(getClientItem('Token')).then(function (response) {
            if (response.Authentication.ErrorDescription != "Invalid input data") {
                setArrayCustomerInfo(response.Authentication);

            }
            else {

                Alerts.ShowAlert(t.error, t.errorGettingCustomerInfo + response.Authentication.ErrorDescription, 'error');

            }
        })
            .catch(function (error) {

                Alerts.ShowAlert(t.error, t.errorGettingCustomerInfo + error.response.data.Authentication.ErrorDescription, 'error');
            })
    }

    const handleStatebyCountry = async (selectedCountryCode, setState) => {
        await GetStatesbyCountry(selectedCountryCode).then(async function (response) {
            var i = 0;
            const filtered = response.Authentication.map(item => {
                const {
                    Code,
                    Name } = item;

                return { Key: i++, Code, Name }
            });
            setArrayStates(filtered);
            if (setState) {
                if (filtered.length > 1)
                    setStateCode(filtered[1].Code);
                else
                    setStateCode(filtered[0].Code);
            }
        })
    }
    async function doRequestACHPayout(Amount, accountnumber, routingnumber, bankname, bankstate, bankcity, bankaddress, firstname, lastname, accountType, telephone, city, zipcode, address) {
        if (parseFloat(Amount.replace(",", "").replace(" ", "")) < parseFloat(clientInfo.WithdrawalBalance.replace(",", "")) && parseFloat(Amount.replace(",", "").replace(" ", "")) > 0) {
            var PayoutData = {
                "Token": getClientItem('Token'),
                "Amount": Amount.replace(",", ""),
                "CurrencyCode": clientInfo.CurrencyCode,
                "ProcessorName": arrayPayouts?.PayoutID,
                "IPv4Address": clientInfo.IPAddress,
                "Comments": '',
                "BankName": bankname,
                "BankCity": bankcity,
                "BankState": bankstate,
                "CheckAccountNumber": accountnumber,
                "CheckRoutingNumber": routingnumber,
                "CheckAccountName": firstname + lastname,
                "CheckAccountState": stateCode,
                "CheckAccountType": accountType,

            };

            await RequestACHPayout(PayoutData).then(function (response) {

                try {
                    var payload = {
                        TransactionID: response.Authentication.TransactionID,
                        Amount: amount,
                        Status: response.Authentication.Status,
                        ProcessorName: arrayPayouts?.PayoutID
                    }

                    window.parent.postMessage(
                        { 'transactionInfo': payload },
                        '*'
                    );
                }
                catch (error) { }

                if (response.Authentication.ErrorCode === "") {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen(t.withdrawalStatus, response.Authentication.HtmlResponse, 'info');
                    else
                        Alerts.ShowAlert(t.withdrawalStatus, response.Authentication.HtmlResponse, 'info');
                    navigate('/payouts/');
                } else {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen(t.withdrawalStatus, response.Authentication.HtmlResponse, 'warning');
                    else
                        Alerts.ShowAlert(t.withdrawalStatus, response.Authentication.HtmlResponse, 'warning');
                }
            }).catch(function (error) {
                Alerts.ShowAlert(t.withdrawalStatus, error.response.data.Authentication.HtmlResponse, 'error');
            })
        }
        else {
            if (isMobile)
                Alerts.ShowAlertFullScreen(t.withdrawalStatus, t.amountNotPermitted, 'warning');
            else
                Alerts.ShowAlert(t.withdrawalStatus, t.amountNotPermitted, 'warning');
        }

    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, accountnumber, routingnumber, bankname, bankstate, bankcity, bankaddress, firstname, lastname, accountType, telephone, city, zipcode, address } = Object.fromEntries(data.entries());

            if (amount != '') {
                setIsProcessing(true);
                setOriginalAmount(amount);
                await doRequestACHPayout(amount, accountnumber, routingnumber, bankname, bankstate, bankcity, bankaddress, firstname, lastname, accountType, telephone, city, zipcode, address);
                setIsProcessing(false);


            }
            else {
                Alerts.ShowAlert(t.warning, t.amountRequired, 'warning');
            }

        }
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/" + arrayPayouts?.ImageName + ".svg"} />  <span className="payout-title">{t.withdrawUsing} {arrayPayouts?.PayoutID} </span>
                    </span>
                </div>
                <div className="row">
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="accountnumber" className="col-sm-12">{t.accountNumber}</label>
                        <input type="text" className="form-control" id="accountnumber" aria-describedby="lblAddress" placeholder={t.accountNumberPlaceholder} name="accountnumber" required="required" />
                    </div>
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="routingnumber" className="col-sm-12">{t.routingNumber}</label>
                        <input type="text" className="form-control" id="routingnumber" aria-describedby="lblAddress" placeholder={t.routingPlaceholder} name="routingnumber" maxLength="9" required="required" />
                    </div>
                    <div className="col-md-4 col-sm-12 m3">
                        <label for="ccCurrency" className="col-sm-12">{t.amount}</label>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                    <select className="form-control selectcurrency" disabled name="ccCurrency" required value={clientInfo.CurrencyCode}>
                                        <option value="" className="">{t.currency}</option>
                                        <option value="USD">USD</option>
                                    </select>
                                </span>
                            </div>
                            <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder={t.amountPlaceholder} max={arrayPayouts?.MaxPayout === 0 ? MAXLIMIT : arrayPayouts?.MaxPayout} min={arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} name="amount" required="required" value={amount} onChange={(e) => setAmount(e.target.value)} readOnly={fixedAmount > 0} />
                        </div>

                        <div className="d-flex flex-row ml-2 limit-text-center" style={{ marginBottom: '4px' }}>
                            {t.payoutLimits} {arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} USD {t.maximum} {arrayPayouts?.MaxPayout === 0 ? t.noLimit : arrayPayouts?.MaxPayout + ' USD'}
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-12 mb-5">
                        <label for="accountType" className="col-sm-12">{t.accountType}</label>
                        <select className="form-select border-teal" value="200510" id="accountType" name="accountType"
                            tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Account Type" required >
                            {CheckTypes.map((item) => <option key={item.Key} value={item.value}>{item.text}</option>
                            )}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-title-color mb-4">
                        <h3>{t.bankInformation}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="bankname" className=" col-sm-12">{t.bankName}</label>
                        <input type="text" className="form-control" id="bankname" aria-describedby="bankname" placeholder={t.bankNamePlaceholder} name="bankname" required="required" />
                    </div>
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="banknumber" className=" col-sm-12">{t.bankNumber}</label>
                        <input type="text" className="form-control" id="banknumber" aria-describedby="banknumber" placeholder={t.bankNumberPlaceholder} name="banknumber" required="required" />
                    </div>
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="bankstate" className=" col-sm-12">{t.bankState}</label>
                        <select id="bankstate" name="bankstate" className="form-select border-teal" value={stateCode} onChange={(event) => setStateCode(event.target.value)}
                            tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Select the State" required>
                            {arrayStates.map((item) => <option key={item.Key} value={item.Code}>{item.Name}</option>
                            )}
                        </select>
                    </div>
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="bankcity" className=" col-sm-12">{t.bankCity}</label>
                        <input type="text" className="form-control" id="bankcity" aria-describedby="bankcity" placeholder={t.bankCityPlaceholder} name="bankcity" required="required" />
                    </div>
                </div>
                <div className="row">
                </div>
                <div className="row">
                    <div className="col-12 text-title-color mt-4 mb-4">
                        <h3>{t.personalInformation}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="firstname" className=" col-sm-12">{t.firstName}</label>
                        <input type="text" className="form-control" id="firstname" aria-describedby="firstname" placeholder={t.firstNamePlaceholder} name="firstname" required="required" value={arrayCustomerInfo.Name} />
                    </div>
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="lastname" className="col-sm-12">{t.lastName}</label>
                        <input type="text" className="form-control" id="lastname" aria-describedby="lastname" placeholder={t.lastNamePlaceholder} name="lastname" required="required" value={arrayCustomerInfo.LastName} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="country" className="col-sm-12">{t.country}</label>
                        <input type="text" className="form-control color-gray border-teal" name="country" aria-label="country" value={arrayCustomerInfo.Country} placeholder={arrayCustomerInfo.Country == '' ? t.countryPlaceholder : arrayCustomerInfo.Country} disabled="disabled" />
                    </div>
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="state" className=" col-sm-12">{t.state}</label>
                        <input type="text" className="form-control color-gray border-teal" name="state" aria-label="state" value={arrayCustomerInfo.State} placeholder={arrayCustomerInfo.State == '' ? t.stateProvPlaceholder : arrayCustomerInfo.State} disabled="disabled" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/payouts/')}>{t.back}</button>
                        <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">{t.submit}</button>
                    </div>
                </div>


            </form>
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>
    );

}
